import { app } from '@src/store/modules/app';
import { login } from '@store/modules/login';
import { redirect } from '@src/utils/client';
import { RouteConfig } from 'vue-router';
import { validateRouteAndNavigate } from './login-state-guards';

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const loginRoutes: Array<RouteConfig> = [
	{
		path: `/login-verify`,
		name: 'login-two-factor',
		beforeEnter: async (to, from, next) => {
			if (app.isAuthenticated) {
				redirect('/account/overview');
			} else {
				try {
					await login.storeTwoFactorMetadata();
					next();
				} catch {
					next({ name: 'forbidden' });
				}
			}
		},
		component: () =>
			import(/* webpackChunkName: "login-two-factor-select" */ '@views/account/login/login-two-factor.vue'),
		redirect: { name: 'login-two-factor-select' },
		children: [
			{
				path: `select`,
				name: 'login-two-factor-select',
				beforeEnter: async (to, from, next) => {
					login.resetTwoFactorSelections();
					await validateRouteAndNavigate(next, 'login-two-factor-select');
				},
				component: () =>
					import(
						/* webpackChunkName: "login-two-factor-select" */ '@src/views/account/login/login-two-factor-select.vue'
					)
			},
			{
				path: `confirm`,
				name: 'login-two-factor-confirm',
				beforeEnter: async (to, from, next) => {
					await validateRouteAndNavigate(next, 'login-two-factor-confirm');
				},
				component: () =>
					import(
						/* webpackChunkName: "login-two-factor-confirm" */ '@src/views/account/login/login-two-factor-confirm.vue'
					)
			}
		]
	},
	{
		path: `/locked-out`,
		name: 'login-locked-out',
		component: () => import(/* webpackChunkName: "login-locked-out" */ '@views/account/login/login-locked-out.vue')
	}
];
export default loginRoutes;
